var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "57px",
    viewBox: "0 0 58 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "1.98%",
    x2: "100%",
    y2: "98.02%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FBFC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3214F2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.7677244,-1.62467147e-15 L32.2322756,-1.88996806e-16 C38.4105004,1.09812587e-16 40.6508741,0.643281485 42.9095407,1.85122964 C45.1682074,3.05917779 46.9408222,4.83179261 48.1487704,7.09045927 C49.3567185,9.34912594 50,11.5894996 50,17.7677244 L50,31.2322756 C50,37.4105004 49.3567185,39.6508741 48.1487704,41.9095407 C46.9408222,44.1682074 45.1682074,45.9408222 42.9095407,47.1487704 C40.6508741,48.3567185 38.4105004,49 32.2322756,49 L17.7677244,49 C11.5894996,49 9.34912594,48.3567185 7.09045927,47.1487704 C4.83179261,45.9408222 3.05917779,44.1682074 1.85122964,41.9095407 C0.643281485,39.6508741 8.04952858e-16,37.4105004 -1.38539236e-15,31.2322756 L-4.28275917e-16,17.7677244 C2.48840641e-16,11.5894996 0.643281485,9.34912594 1.85122964,7.09045927 C3.05917779,4.83179261 4.83179261,3.05917779 7.09045927,1.85122964 C9.34912594,0.643281485 11.5894996,9.43980913e-16 17.7677244,-1.62467147e-15 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.0%",
    y: "-10.2%",
    width: "128.0%",
    height: "128.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.031372549   0 0 0 0 0.149019608   0 0 0 0 0.658823529  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Light-",
    transform: "translate(-743.000000, -1122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(202.000000, 1094.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(545.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-9"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "smart-notifications",
    transform: "translate(15.000000, 10.780000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5185594,3.17837834 C12.4163201,3.58860506 12.3527691,4.01369682 12.3319103,4.44972969 L3.8920058,4.44972969 C2.4591444,4.44972969 1.2972973,5.58841952 1.2972973,6.99254412 L1.2972973,19.7058343 C1.2972973,21.1100385 2.4592256,22.2486486 3.8920058,22.2486486 L16.8647509,22.2486486 C18.2976124,22.2486486 19.4594595,21.1099589 19.4594595,19.7058343 L19.4594595,11.4347279 C19.904391,11.4142863 20.3381581,11.3520063 20.7567568,11.2518118 L20.7567568,19.7058343 C20.7567568,21.8119535 19.0142464,23.52 16.8647509,23.52 L3.8920058,23.52 C1.7429046,23.52 0,21.8123398 0,19.7058343 L0,6.99254412 C0,4.88642494 1.7425104,3.17837834 3.8920058,3.17837834 L12.5185594,3.17837834 Z M19.1351351,9.53513511 C16.4483445,9.53513511 14.2702703,7.40062239 14.2702703,4.7675676 C14.2702703,2.13451272 16.4483445,0 19.1351351,0 C21.8219258,0 24,2.13451272 24,4.7675676 C24,7.40062239 21.8219258,9.53513511 19.1351351,9.53513511 Z",
    id: "Icon"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHd);
export default __webpack_public_path__ + "static/media/hd.d59d986cc0e81c13f4ca0b96acf73272.svg";
export { ForwardRef as ReactComponent };